import { flattenReduxFormProps } from 'decorators';
import { RadioGroup } from 'components/core/RadioInput';

export default flattenReduxFormProps(RadioGroup);
